import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { updateUserStatusByAdmin } from '~/redux/actions/admin-users-actions';
import { success, failure } from '~/redux/actions/snackbar-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import ConfirmModal from '~/components/General/ConfirmModal';

const ActionModal = (props) => {
  const { openModal, handleCloseModal, selectedUser, getAdminUsers } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      setLoading(true);
      let payload = {
        id: selectedUser?.id,
        status: selectedUser?.status === 'Blocked' ? 'Approved' : 'Blocked',
      };
      const response = await dispatch(updateUserStatusByAdmin(payload));
      if (response.status === 200) {
        getAdminUsers();
        dispatch(success(response.data.message));
        handleCloseModal();
      } else {
        dispatch(failure(response?.data?.message));
      }
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      openConfirmModal={{
        open: openModal,
        header:
          selectedUser?.status === 'Blocked'
            ? MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.ENABLE_TITLE
            : MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.DISABLE_TITLE,
        message:
          selectedUser?.status === 'Blocked'
            ? MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.ENABLE_HEADING
            : MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.DISABLE_HEADING,
        handleOk: onSubmit,
        handleClose: handleCloseModal,
        loading,
        successButtonName: MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.SUBMIT_BUTTON,
        cancelButtonName: MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.CANCEL_BUTTON,
        compactActions: true,
      }}
    />
  );
};

export default ActionModal;
